export const environment = {
  production: false,
  env: 'develop',
  baseUrlAPI: 'https://0tvxrr8ci8.execute-api.us-east-1.amazonaws.com/prod',
  baseUrlAPINEW: 'https://manage-api.cbntech.xyz',
  baseWssAPI: ''
};
